import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => {
  return {
    formControl: {
      minWidth: 120,
      marginBottom: 15,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    select: {
      background: '#fff',
      textTransform: 'capitalize',
      textAlign: 'left',
    },
    capitalize: {
      textTransform: 'capitalize',
    },
  };
});

export default function SimpleSelect(props) {
  const {
    name, value, handleChange, data, title, selectValue, selectName, isArray, disabled, handleBlur, noDefault,
    headTitle,
  } = props;
  const classes = useStyles();

  const _id = selectValue || '_id';
  const displayName = selectName || 'name';

  const onBlur = () => {
    if (handleBlur) handleBlur();
  };

  return (
    <div>
      <FormControl fullWidth variant="outlined" className={classes.formControl}>
        <InputLabel id="select-outlined-label">{headTitle || `Select ${title}`}</InputLabel>
        <Select
          labelId="select-outlined-label"
          id="select-outlined"
          name={name}
          value={value}
          onChange={handleChange}
          label={headTitle || `Select ${title}`}
          disabled={disabled || false}
          className={classes.select}
          onBlur={onBlur}
        >
          {
            noDefault ? null
              : (
                <MenuItem value="">
                  <em>{`Select ${title}`}</em>
                </MenuItem>
              )
          }
          {
            isArray ? data && data.map((item) => {
              return <MenuItem key={item} value={item} className={classes.capitalize}>{item}</MenuItem>;
            })
              : data && data.map((item) => {
                return (
                  <MenuItem key={item[_id]} value={item[_id]}>
                    {item[displayName]}
                  </MenuItem>
                );
              })
          }
        </Select>
      </FormControl>
    </div>
  );
}
